/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StreakOutcome } from './StreakOutcome';
import {
    StreakOutcomeFromJSON,
    StreakOutcomeFromJSONTyped,
    StreakOutcomeToJSON,
    StreakOutcomeToJSONTyped,
} from './StreakOutcome';

/**
 * A tier in per-window outcome escalation
 * @export
 * @interface StreakEscalationTier
 */
export interface StreakEscalationTier {
    /**
     * Minimum streak length for this tier to activate
     * @type {number}
     * @memberof StreakEscalationTier
     */
    minStreak: number;
    /**
     * 
     * @type {Array<StreakOutcome>}
     * @memberof StreakEscalationTier
     */
    outcomes: Array<StreakOutcome>;
}

/**
 * Check if a given object implements the StreakEscalationTier interface.
 */
export function instanceOfStreakEscalationTier(value: object): value is StreakEscalationTier {
    if (!('minStreak' in value) || value['minStreak'] === undefined) return false;
    if (!('outcomes' in value) || value['outcomes'] === undefined) return false;
    return true;
}

export function StreakEscalationTierFromJSON(json: any): StreakEscalationTier {
    return StreakEscalationTierFromJSONTyped(json, false);
}

export function StreakEscalationTierFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakEscalationTier {
    if (json == null) {
        return json;
    }
    return {
        
        'minStreak': json['minStreak'],
        'outcomes': ((json['outcomes'] as Array<any>).map(StreakOutcomeFromJSON)),
    };
}

export function StreakEscalationTierToJSON(json: any): StreakEscalationTier {
    return StreakEscalationTierToJSONTyped(json, false);
}

export function StreakEscalationTierToJSONTyped(value?: StreakEscalationTier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'minStreak': value['minStreak'],
        'outcomes': ((value['outcomes'] as Array<any>).map(StreakOutcomeToJSON)),
    };
}

